// @ts-ignore
import { datePopups as popups } from 'react-widgets/lib/util/constants';
import { DateTimePicker as ReactDateTimePicker } from 'lib/ReactWidgets';
import { MouseEventHandler } from 'types/typescript/eventHandlers';
import cx from 'classnames';
import Glyph from 'components/Glyph';
import InputConstants from 'constants/InputConstants';
import PropTypes from 'prop-types';
import * as React from 'react';

import withDateTimePickerPosition from 'components/lib/withDateTimePickerPosition';

import './styles/TimePickerInput.scss';

/**
 * ## Time input wrapping a [React Widget](https://jquense.github.io/react-widgets/docs/#/datetime-picker).
 *
 *
 * ```example
 * <TimePickerInput />
 * ```
 *
 *
 * # TODO
 * * Reconcile children & styles with [DatePickerInput](/internal/components/DatePickerInput)
 */

type DateTimePickerProps = {
  max?: Date;
  min?: Date;
  placeholder?: string;
  value?: Date;
}

type DefaultProps = {
  closePopup: () => void;
  error: boolean;
  opened: boolean;
  focused: boolean;
  onBlur: () => void;
  onChange: (date?: Date, dateStr?: string) => void;
  onFocus: () => void;
  onPickerClick: MouseEventHandler;
}

type Props = {
  disabled?: boolean;
  className?: string;
  'data-test'?: string;
} & DefaultProps & DateTimePickerProps;

class TimePickerInput extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    closePopup: () => {},
    onBlur: () => {},
    onChange: () => {},
    onFocus: () => {},
    onPickerClick: () => {},
    error: false,
    opened: false,
    focused: false,
  }

  handleClick: MouseEventHandler = event => {
    const { disabled, onPickerClick } = this.props;

    if (!disabled) {
      onPickerClick(event);
    }
  };

  render() {
    const {
      className,
      closePopup,
      disabled,
      error,
      focused,
      onBlur,
      onChange,
      onFocus,
      opened,
      ...otherProps
    } = this.props;
    const open = opened ? popups.TIME : false;
    const active = focused || opened;

    return (
      <div
        className={cx(
          'TimePickerInput',
          {
            'TimePickerInput--disabled': disabled,
            'TimePickerInput--error': error,
            'TimePickerInput--focused': active,
          },
          className
        )}
        onClick={this.handleClick}>
        <ReactDateTimePicker
          {...otherProps}
          duration={0}
          format="h:mm tt"
          open={open}
          parse={['h:mm tt', 'h:mmtt', 'HH:mm']}
          ref="picker"
          step={5}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={closePopup}
          onToggle={() => {}}
          data-test={this.props['data-test']}
        />
        <Glyph
          color={active ? InputConstants.ACTIVE_GLYPH_COLOR : InputConstants.GLYPH_COLOR}
          name="clock"
          size={InputConstants.GLYPH_SIZE}
        />
      </div>
    );
  }
}
// $FlowFixMe 0.93.0 finally decided this wasn't gonna work (withDateTimePickerPosition is borked too)
export default withDateTimePickerPosition(TimePickerInput);
